import React, { useState } from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Certifications from "./components/Certifications";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import CherryBlossoms from "./components/CherryBlossoms";
import LoadingScreen from "./components/LoadingScreen";
import ScrollingKatana from "./components/ScrollingKatana";
import ToriiGateDivider from "./components/ToriiGateDivider";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="App bg-black min-h-screen">
      {isLoading && (
        <LoadingScreen onLoadingComplete={() => setIsLoading(false)} />
      )}
      
      {!isLoading && (
        <>
          <CherryBlossoms />
          <ScrollingKatana />
          <Header />
          <main>
            <Hero />
            <About />
            <ToriiGateDivider />
            <Skills />
            <Experience />
            <ToriiGateDivider />
            <Projects />
            <Certifications />
            <ToriiGateDivider />
            <Contact />
          </main>
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
